export enum RDeploymentType {
    ENTERPRISE = 'Enterprise',
    SERVICE_PROVIDER = 'ServiceProvider'
}


// Create a Map for displaying the RDeploymentType values
export const toDisplayDeploymentType: Map<RDeploymentType, string> = new Map<RDeploymentType, string>([
    [RDeploymentType.ENTERPRISE, 'Enterprise'],
    [RDeploymentType.SERVICE_PROVIDER, 'Service Provider']
]);

// Create a Map for converting stored strings to RDeploymentType values
export const fromStoredDeploymentType: Map<string, RDeploymentType> = new Map<string, RDeploymentType>([
    ['va', RDeploymentType.ENTERPRISE],
    ['sp', RDeploymentType.SERVICE_PROVIDER]
]);
